export const truncateFileName = (
  fileName: string,
  maxLength: number,
  isMobile: boolean,
) => {
  if (!isMobile || fileName.length <= maxLength) {
    return fileName
  }
  const start = fileName.substring(0, maxLength / 2 - 2)
  const end = fileName.substring(fileName.length - maxLength / 2 + 1)
  return `${start}...${end}`
}
